<template>
  <el-dialog
    :title="fileType == 1 ? '上传交付物' : '上传成果验收单'"
    width="30%"
    :visible.sync="show"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialogBox">
      <el-alert
        title="请上传创客接单完成情况截图或者平台佣金结算依据截图"
        show-icon
        type="warning"
        :closable="false"
        style="margin-bottom: 18px; flex-shrink: 0"
      >
      </el-alert>
      <div style="display: flex; margin-bottom: 18px;" class="flex-box">
        <div class="text">
          上传交付物：
        </div>
        <MultipleUpload
          :modelValue="deliverableList"
          :config="config"
          @update="uploadMul"
          :fileSuffix="fileSuffix"
        ></MultipleUpload>
      </div>
      <div style="display: flex" class="flex-box">
        <div class="text">
          交付物描述：
        </div>
        <el-input v-model="detail.deliverableDesc" placeholder="请输入交付物描述" type="textarea" :rows="4" style="width: 322px"></el-input
        >
      </div>
    </div>
    <div slot="footer">
      <el-button plain @click="show = !show">取 消</el-button>
      <el-button @click="submit" type="primary" :loading="btnloadSubmit">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MultipleUpload from "@/components/formView/multipleUpload.vue";
import { downloadDocx, downloadUrl } from "@/utils";
export default {
  components: { MultipleUpload },
  data() {
    return {
      btnloadSubmit: false,
      show: false,
      fileType: 1,
      deliverableList: [],
      detail: {
        id: "",
        deliverableUrl:"",
        deliverableDesc:""
      },
      fileSuffix: ["jpg", "png", "jpeg", "pdf", "zip", "rar", "txt"],
      config: {
        disabled: false,
      },
    };
  },
  methods: {
    // 数据清空
    clear() {
      Object.assign(this.$data, this.$options.data());
    },
    // 打开弹窗
    open(obj) {
      this.show = true;
      console.log("obj",obj);
      this.detail.id = obj.id;
    },
    // 提交操作
    async submit() {
      if (this.deliverableList.length == 0) {
        this.$message.error("请上传文件");
        return false;
      }
      this.btnloadSubmit = true;
      this.deliverableList.map((item) => {
        item.url = item.fileUrl;
        item.name = item.fileName;
      });
      this.detail.deliverableUrl = this.deliverableList[0].fileUrl;
      console.log("this.detail",this.detail);
      const result = await this.$api
        .UploadSupplierPeopleDeliverableInfo(this.detail)
        .finally(() => {
          this.btnloadSubmit = false;
        });
      if (result) {
        this.$message.success("上传成功");
        this.show = false;
        this.$emit('submit')
        this.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogBox {
  .text {
    margin-top: 5px;
  }
  .accpent {
    margin-bottom: 20px;
    .title {
      font-size: 16px;
      font-weight: bold;
      margin: 15px 0;
      color: #303133;
    }
    .result-text {
      color: #409eff;
      cursor: pointer;
    }
    .text {
      margin-bottom: 10px;
    }
  }
}
</style>
